import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const projectImporterSelectors = importerSelectors('project.importer');

export default projectImporterSelectors;
